/**
 * Feedback Service - Submit user feedback
 * Auth is optional (JWT passed if available)
 */

import { httpClient } from '@/lib/http'

/**
 * POST /api/v1/feedback
 * Submit feedback (auth optional - pass JWT if user is logged in)
 * Rate limited: 5/day authenticated, 2/day anonymous (resets midnight UTC)
 */
export async function submitFeedback(content: string): Promise<void> {
  await httpClient.post('/feedback', { content })
}
